import { Link } from "react-router-dom";
import Container from "@/components/base/Container";
import SectionHeading from "@/components/base/SectionHeading";
import TagPill from "@/components/base/TagPill";
import { hotTopics } from "@/mocks/hotTopics";

const trendIcon = (trend: string) => {
  if (trend === "up") return { icon: "ri-arrow-up-line", color: "text-primary-600" };
  if (trend === "down") return { icon: "ri-arrow-down-line", color: "text-secondary-600" };
  return { icon: "ri-subtract-line", color: "text-foreground-400" };
};

export default function HotTopicsSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <Container>
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="REAL-TIME"
            title="热点速览：大家正在讨论什么"
            description="按讨论规模排出的当日话题榜，每一条都对应一篇可展开的对比或解读。"
          />
          <Link
            to="/compare"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部话题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-x-10 gap-y-2 lg:grid-cols-2">
          {hotTopics.map((topic) => {
            const t = trendIcon(topic.trend);
            return (
              <Link
                key={topic.id}
                to="/compare"
                className="group flex items-start gap-4 rounded-lg border border-transparent px-3 py-4 transition-colors hover:border-background-200 hover:bg-background-100"
              >
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                    topic.rank <= 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {topic.rank}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="flex items-start gap-2">
                    <span className="text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-[15px]">
                      {topic.title}
                    </span>
                    <span className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center ${t.color}`}>
                      <i className={`${t.icon} text-base`} />
                    </span>
                  </span>
                  <span className="mt-2 flex flex-wrap items-center gap-2">
                    <TagPill variant="outline">{topic.category}</TagPill>
                    <span className="text-xs text-foreground-500">
                      热度 {topic.heat.toLocaleString()}
                    </span>
                  </span>
                </span>
              </Link>
            );
          })}
        </div>
      </Container>
    </section>
  );
}